import PropTypes from 'prop-types';

function FreeShippingThresholdIcon({ className, width }) {
    return (
        <svg
            className={className}
            width={width}
            height={Math.round(width * 0.96)}
            viewBox="0 0 24 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.3274 20.9789L1 20.294L2.06352 3.87021L17.3909 4.55514L16.3274 20.9789Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.942261"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.9555 22.1477L16.3274 20.979L17.3909 4.55527L23.019 5.71965L21.9555 22.1477Z"
                fill="#F2D79A"
                stroke="#2D2D2D"
                strokeWidth="0.942261"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 20.294V20.675L8.69987 21.7452L21.9555 22.5158V22.1476L16.3274 20.979L1 20.294Z"
                fill="#2D2D2D"
            />
            <path
                d="M16.7357 2.72809L9.14646 16.4755C9.08716 16.6224 8.98849 16.7498 8.86144 16.8436C8.53813 17.0491 8.13825 16.7709 7.85748 16.5097L3.74805 12.687C3.74805 12.687 4.10113 11.0303 4.59886 11.1887C5.09659 11.3471 7.89576 14.3094 8.05742 13.877C8.21907 13.4447 14.4002 1.2298 14.983 1.28545C15.5659 1.3411 16.7357 2.72809 16.7357 2.72809Z"
                className="fill-[#B0C372] if:fill-[#E95CA2]"
                stroke="#2D2D2D"
                strokeWidth="0.942261"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default FreeShippingThresholdIcon;

FreeShippingThresholdIcon.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number,
};

FreeShippingThresholdIcon.defaultProps = {
    className: null,
    width: 24,
};
